'use client'

import { Share2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { A11Y_LABELS } from '@/lib/accessibility-labels'

interface ShareButtonProps {
  article: {
    slug: string
    title: string
    summary?: string
  }
}

export default function ShareButton({ article }: ShareButtonProps) {
  const handleShare = async () => {
    const url = typeof window !== 'undefined' ? `${window.location.origin}/news/${article.slug}` : ''

    if (navigator.share) {
      try {
        await navigator.share({
          title: article.title,
          text: article.summary || article.title,
          url,
        })
      } catch (err) {
        // User cancelled share
      }
    } else {
      // Fallback: copy to clipboard
      await navigator.clipboard.writeText(url)
    }
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleShare}
      title={A11Y_LABELS.shareArticle}
      aria-label={A11Y_LABELS.shareArticle}
      className="hover:bg-slate-100 dark:hover:bg-slate-800 touch-target"
    >
      <Share2 className="w-4 h-4" />
    </Button>
  )
}
